<div class="container flex flex-col justify-center items-center">
  <button mat-icon-button class="self-end" (click)="onClose()">
    <mat-icon> close </mat-icon>
  </button>

  <div class="mb-4 pr-3 pl-3 message" [innerHtml]="message"></div>
</div>
